//@ts-nocheck

import styles from './terms.module.css';
import Description from "../atoms/description";
import Modal from '../atoms/modal';
import Loader from '../loader/loader';

export default function Terms({terms, openModal = undefined}) {
    // console.log(terms);
    return (
        <>
            <div className={styles['content-wrapper']}>
                <Description description={terms.content} mode="blog" width={100} openModal={openModal}/>
            </div>
        </>
    )
}
